<mat-form-field appearance="outline" subscriptSizing="dynamic" class="range-calendar-field">
  <mat-label>{{label}}</mat-label>

  <!-- the dual input field: -->
  <mat-date-range-input [formGroup]="dateRangeForm" [rangePicker]="picker">
    <!-- start part -->
    <input matStartDate formControlName="from" placeholder="Od"/>
    <!-- end part -->
    <input matEndDate formControlName="to" placeholder="Do"/>
  </mat-date-range-input>

  <!-- the picker trigger button -->
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>

  <!-- the actual picker -->
  <mat-date-range-picker
    #picker [calendarHeaderComponent]="CalendarRangeHeaderComponent"></mat-date-range-picker>
</mat-form-field>
